var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"c-umbraco-image-ext",class:{
		'c-umbraco-image-ext--lazyload': _vm.lazyload,
		'c-umbraco-image-ext--has-loaded': _vm.hasLoaded,
	},style:(_vm.computedAspectRatio && `--aspect-ratio: ${_vm.computedAspectRatio}`)},[(_vm.imageAttrs.sourceUrl)?_c('UmbracoImage',_vm._g(_vm._b({},'UmbracoImage',_vm.imageAttrs,false),_vm.$listeners)):_vm._e(),_vm._v(" "),(_vm.credit)?_c('small',{staticClass:"c-umbraco-image-ext__credit",domProps:{"textContent":_vm._s(_vm.credit)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }